<script>
	export let file_path
	export let alt

	$: src = `https://img.trex-arms.com/${ file_path }?w=250&auto=format,compress`

	const dprs_in_srcset = [ 1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5 ]
	$: srcset = dprs_in_srcset.map(dpr => src + `&dpr=${ dpr } ${ dpr }x`).join(`, `)
</script>

<img
	{src}
	{srcset}
	{alt}
/>

<style>
	img {
		display: block;
	}
</style>
